const SettingsAccessibility = () => <>hello world!</>;

export default SettingsAccessibility;
